<p>cms-resource-exoplorer-parent-base works!</p>,
